<script setup>
import { computed } from 'vue';

const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

// Amber means "stalled until something outside this screen happens" — Meta working, or the
// admin having to do something at Meta; blue "ready for the admin here", teal done, ruby
// failed. Spelled out per status rather than composed, so Tailwind's scanner sees every class.
const CLASSES = {
  draft: 'text-n-slate-11 bg-n-alpha-2',
  cloning: 'text-n-amber-11 bg-n-amber-3',
  ready_to_complete: 'text-n-blue-text bg-n-blue-3',
  action_required: 'text-n-amber-11 bg-n-amber-3',
  completing: 'text-n-amber-11 bg-n-amber-3',
  completed: 'text-n-teal-11 bg-n-teal-3',
  failed: 'text-n-ruby-11 bg-n-ruby-3',
};

const badgeClass = computed(() => CLASSES[props.status] ?? CLASSES.draft);

const label = computed(
  () => `CLIENT_SETTINGS.CURRENCY_MIGRATION.STATUS.${props.status.toUpperCase()}`
);
</script>

<template>
  <span
    class="px-2 py-0.5 text-xs font-medium rounded-md whitespace-nowrap"
    :class="badgeClass"
    :data-testid="`migration-status-${status}`"
  >
    {{ $t(label) }}
  </span>
</template>
